import React, { Component } from "react";
import { withRouter, Link, NavLink } from "react-router-dom";
// import { connect } from "react-redux";

//Miscellaneous
import moment from "moment";
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";

//Icons
import { Icon } from "@iconify/react";

class PageFooter extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
  }

  imageImport = (r) => {
    let images = {};
    r.keys().map((item) => {
      return (images[item.replace("./", "")] = r(item)["default"]);
    });
    return images;
  };

  render() {
    const img = this.imageImport(require.context("../../assets/images", false, /\.(png|jpe?g|svg)$/));
    return (
      <Auxiliary>
        <footer>
          <div className="x-container-no-m">
            <div className="footer-one">
              <span>
                <p className="mb-3">Payment Method</p>
                <img src={img["fpx-logo.svg"]} alt="fpx-logo" />
                <img src={img["tether.svg"]} alt="tether-logo" />
              </span>
              <NavLink to={{ pathname: "/certificate" }}>
                <span className="p-0">
                  <p className="mb-3">Licenses</p>
                  <span>
                    <img src={img["fcl.svg"]} alt="fcl-logo" />
                    <img src={img["pagcor.svg"]} alt="pagcor-logo" />
                    <img src={img["ifm-logo.svg"]} alt="ifm-logo" />
                  </span>
                </span>
              </NavLink>
            </div>
          </div>
          <hr />
          <div className="x-container-no-m">
            <div className="footer-two">
              <p>
              X33 has legal licenses issued by the European Malta (MGA) and the Philippine Government Guessing Committee (PAGCOR). Registered in the British Virgin Islands, it is a legal company recognized by the international industry association. Before registering and having fun, please make sure you are at least 18 years old!
              </p>
              <div className="btn-social">
                <a href="/#" target="_blank" rel="noreferrer" onClick={() => { window.open("https://www.facebook.com/x33-214127967292770"); }}>
                  <Icon icon="uil:facebook-f" />
                </a>
                <a href="/#" target="_blank" rel="noreferrer" onClick={() => { window.open("https://www.instagram.com/x33_asia/"); }}>
                  <Icon icon="uil:instagram" />
                </a>
                <a href="/#" target="_blank" rel="noreferrer" onClick={() => { window.open("https://www.youtube.com/channel/UCrQkPJ7RXZeGbTztO61W-gQ"); }}>
                  <Icon icon="uil:youtube-alt" />
                </a>
                <Link to="/#" target="_blank" rel="noreferrer">
                  <Icon icon="uil:whatsapp" />
                </Link>
              </div>
              <small>&#0169; X33 | {moment().format("YYYY")}. All right reserved.</small>
            </div>
          </div>
        </footer>
      </Auxiliary>
    );
  }
}

export default PageFooter;
